import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_buttonTextIconNew(walkedNode) {

  supplyEventInAction(walkedNode)
}
